import React, { useEffect, useState } from "react";
import { useStateContext } from "../contexts/ContextProvider";
import { UALProvider } from "ual-reactjs-renderer";
import { Helmet } from "react-helmet";
import {
  Modal,
  ModalContent,
  Spinner,
  SpinnerRed,
  SpinnerBlue,
  SpinnerGreen,
  GameButton,
} from "../components/LeftDiv";
import {
  wax,
  anchor,
  myChain,
  currentUsername,
  wombat,
  currentWebsiteURL,
  APP_NAME,
  CONTRACT_NAME,
} from "../data/config";
import {
    FoldersContainer,
  FoldersRow,
  MainButton,
  MilestoneContainer,
  MilestoneDescription,
  NewListingBody,
  NewListingCont,
  SingleFolderThird,
  TallFiltersCont,
  TallFiltersInnerCont,
  theme,
} from "../Styles";


import Error from "../components/Error";

import LoadingPage from "../components/LoadingPage";
import { useGetListingsByUser } from "../components/CustomHooks/useGetListingsByUser";
import { showBalances, showListings } from "../data/functions/control_panel";
import { useGetUserData } from "../components/CustomHooks/useGetUserData";
import { useGetUserBalances } from "../components/CustomHooks/useGetUserBalances";
import WithdrawModal from "../components/WithdrawModal";

const ControlPanel = ({ location }) => {
  const {
    enterModalText,
    setEnterModalText,
    loadingDisplay,
    setLoadingDisplay,
    setEnterButtonsDisplay,
    enterModalDisplay,
    setEnterModalDisplay,
  } = useStateContext();

  const [currentTab, setCurrentTab] = useState("Listings");
  const [refresh, setRefresh] = useState(0);  
  const [amountToWithdraw, setAmountToWithdraw] = useState("");
  const [showWithdrawModal, setShowWithdrawModal] = useState(false);
  const [selectedToken, setSelectedToken] = useState("");
  const [selectedPrecision, setSelectedPrecision] = useState(null);
  const [selectedContract, setSelectedContract] = useState("");
  const [tokenAction, setTokenAction] = useState("");
  
  //custom hooks
  const [listings, getAllListings, listingsAreLoading] = useGetListingsByUser();
  const [userData, getUserData, userIsLoading] = useGetUserData();
  const [balances, getUserBalances, balancesAreLoading] = useGetUserBalances();


  useEffect(() => {
    if(currentUsername){
        getAllListings(currentUsername);
    }
  }, [refresh])

  useEffect(() => {
    if(currentUsername && !listingsAreLoading){
        getUserData(currentUsername);
    }
  }, [listingsAreLoading])  

  useEffect(() => {
    if(currentUsername && !listingsAreLoading && !userIsLoading){
        getUserBalances(currentUsername);
    }
  }, [listingsAreLoading, userIsLoading])    

if(currentUsername && !listingsAreLoading && !userIsLoading && !balancesAreLoading){
    return (
      <div id="seo">
        <Helmet>
          <title>Control Panel</title>
          <meta
            name="description"
            content=""
          />
          <link rel="canonical" href={`${currentWebsiteURL}/wallet`} />
        </Helmet>

        <UALProvider
          chains={[myChain]}
          authenticators={[anchor, wax, wombat]}
          appName={APP_NAME}
        >
          <Modal className={enterModalDisplay}>
            <ModalContent>{enterModalText}</ModalContent>

            <Spinner style={{ display: loadingDisplay }}>
              <SpinnerRed />
              <SpinnerBlue />
              <SpinnerGreen />
            </Spinner>

            <br />
            <GameButton onClick={() => setEnterModalDisplay("hidden")}>
              Close Window
            </GameButton>
          </Modal>

          <WithdrawModal showWithdrawModal={showWithdrawModal} setShowWithdrawModal={setShowWithdrawModal}
                token_name={selectedToken} precision={selectedPrecision} contract={selectedContract}
                setEnterModalText={setEnterModalText} setLoadingDisplay={setLoadingDisplay} 
                setEnterButtonsDisplay={setEnterButtonsDisplay} setEnterModalDisplay={setEnterModalDisplay} 
                tokenAction={tokenAction}
                />

            <NewListingCont>
              <NewListingBody>
                <TallFiltersCont>
                <h2>Control Panel</h2>
                </TallFiltersCont>
                

                    <FoldersContainer>
                        <FoldersRow>
                            <SingleFolderThird
                                onClick={() => setCurrentTab("Listings")}
                                selected={currentTab == "Listings" && true}
                            >
                                Listings
                            </SingleFolderThird>

                            <SingleFolderThird
                                onClick={() => setCurrentTab("Balances")}
                                selected={currentTab == "Balances" && true}                            
                            >
                                Balances
                            </SingleFolderThird>
                        </FoldersRow>
                    </FoldersContainer>

        {currentTab == "Listings" && showListings(listings, setEnterModalText, setLoadingDisplay, setEnterButtonsDisplay, setEnterModalDisplay, setRefresh)}
    
        {currentTab == "Balances" && showBalances(userData, balances, tokenAction, setTokenAction, showWithdrawModal, setShowWithdrawModal, selectedToken, setSelectedToken, selectedPrecision, setSelectedPrecision, selectedContract, setSelectedContract, setEnterModalText, setLoadingDisplay, setEnterButtonsDisplay, setEnterModalDisplay)}
              </NewListingBody>
              </NewListingCont>

        </UALProvider>
        <br />
        <br />
        <br />
      </div>
    );}

    else if(((listingsAreLoading || userIsLoading || balancesAreLoading) && currentUsername)){
        return <LoadingPage />
    }
    else if(!currentUsername){
        return(<Error error="You must log in to view your wallet" />)
    }

};

export default ControlPanel;
